import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import { ServiceInterviewApprove } from 'components';
import { apiServiceApproveChecked } from 'api/ZimssaAPI';
import { useServiceStatus } from 'hooks';
import { SERVICE_SELECT, PROFILE_REGISTER, SERVICE_FEATURE_REGISTER, USER_LIST, USER_REGISTER } from 'router/PageUrl';

function ServiceApproveCheckView(): React.ReactElement {
    const history = useHistory();
    const { serviceIdx, serviceType, serviceDocStatus, serviceActiveStatus, serviceState } = useServiceStatus();
    const { isProfile, isMember, isOffer, hasProfileImage } = serviceState;

    const onClickApproveCheckCallback = useCallback(
        () => {
            if (serviceType && serviceIdx) {
                apiServiceApproveChecked(serviceType, Number(serviceIdx))
                    .then((response) => {
                        const { result, message } = response;

                        if (result === 'success') {
                            alert('최종승인 요청을 완료하였습니다.');
                            history.push(SERVICE_SELECT.url);
                        } else {
                            if (message) alert(message);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },
        [history, serviceIdx, serviceType]
    );

    const onClickProfileRegisterCheckCallback = useCallback(
        () => {
            history.push(`${PROFILE_REGISTER.url}/${serviceType}/${serviceIdx}`);
        },
        [history, serviceIdx, serviceType]
    );

    const interviewApproveProps = {
        isActive: (() => {
            if (serviceType === 'familymove') {
                return isProfile && isOffer;
            }

            if (serviceType === 'move_cleaning') {
                return isProfile && isOffer;
            }

            if (serviceType === 'smallmove') {
              return isProfile;
            }

            return false;
        })(),
        isApproveCheck: serviceActiveStatus === 'sign_up' && serviceDocStatus === 'approve_check',
        onClickApproveCheck: isProfile && !(serviceActiveStatus === 'sign_up' && serviceDocStatus === 'approve_check') ? onClickApproveCheckCallback : () => {},
        buttons: (() => {
            if (serviceType === 'smallmove') {
                return [
                    {
                        name: '대표 프로필 만들기 (필수)',
                        onClick:
                            serviceDocStatus === 'interview_approve'
                                ? onClickProfileRegisterCheckCallback
                                : () => {},
                        checked: isProfile,
                    },
                    {
                        name: '제공 서비스 등록하기 (필수)',
                        onClick:
                        serviceDocStatus === 'interview_approve'
                            ? () => {
                                history.push(
                                `${SERVICE_FEATURE_REGISTER.url}/${serviceType}/${serviceIdx}`
                                );
                            }
                            : () => {},
                        checked: isOffer,
                    },
                ];
            }

            if (serviceType === 'familymove') {
                return [
                    {
                        name: '대표 프로필 만들기 (필수)',
                        onClick:
                            serviceDocStatus === 'interview_approve'
                                ? onClickProfileRegisterCheckCallback
                                : () => {},
                        checked: isProfile,
                    },
                    {
                        name: '제공 서비스 등록하기 (필수)',
                        onClick:
                            serviceDocStatus === 'interview_approve'
                                ? () => {
                                    history.push(
                                        `${SERVICE_FEATURE_REGISTER.url}/${serviceType}/${serviceIdx}`
                                    );
                                }
                                : () => {},
                        checked: isOffer,
                    },
                    {
                        name: '직원 등록하기',
                        onClick:
                        serviceDocStatus === 'interview_approve'
                            ? () => {
                                if (isMember) {
                                history.push(
                                    `${USER_LIST.url}/${serviceType}/${serviceIdx}`
                                );
                                } else {
                                history.push(
                                    `${USER_REGISTER.url}/${serviceType}/${serviceIdx}`
                                );
                                }
                            }
                            : () => {},
                        checked: isMember,
                    },
                ];
            }

        if (serviceType === 'move_cleaning') {
            return [
                {
                name: '대표 프로필 만들기 (필수)',
                onClick:
                    serviceDocStatus === 'interview_approve'
                        ? onClickProfileRegisterCheckCallback
                        : () => { },
                    checked: isProfile && hasProfileImage,
                },
                {
                    name: '제공 서비스 등록하기 (필수)',
                    onClick:
                        serviceDocStatus === 'interview_approve'
                            ? () => {
                                history.push(
                                    `${SERVICE_FEATURE_REGISTER.url}/${serviceType}/${serviceIdx}`
                                );
                            }
                            : () => { },
                    checked: isOffer,
                },
                {
                  name: '직원 등록하기',
                  onClick:
                    serviceDocStatus === 'interview_approve'
                      ? () => {
                          if (isMember) {
                            history.push(
                              `${USER_LIST.url}/${serviceType}/${serviceIdx}`
                            );
                          } else {
                            history.push(
                              `${USER_REGISTER.url}/${serviceType}/${serviceIdx}`
                            );
                          }
                        }
                      : () => {},
                  checked: isMember,
                },
            ];
        }

        return [];
    })(),
  };

  return (
    <Template>
      <ServiceInterviewApprove {...interviewApproveProps} />
    </Template>
  );
}

export default ServiceApproveCheckView;
